<div class="lms-agents__content">
  <lms-breadcrumb></lms-breadcrumb>
  <ac-administrators
    [storageKey]="'admins_list'"
    (createAdmin)="onCreateAdmin()"
    lmsClickLink
    lmsClickRow="agents"
  ></ac-administrators>
</div>
